import React from 'react';
import styles from '../ChatWidget.module.scss';

export default function QuickActions() {
  return (
    <div className={styles.quickActions}>
      <button type="button" className={styles.quickActionChip} disabled>
        History
      </button>
      <button type="button" className={styles.quickActionChip} disabled>
        Help
      </button>
    </div>
  );
}
